export default "__VITE_ASSET__C5r2Vx6O__"